import ModalCloneTermCategory from "./modal-clone-term-category";

export default ModalCloneTermCategory;